import { gameState, config } from "@js/state";
export default class EndScene extends Phaser.Scene {
  constructor() {
    super({
      key: "EndScene",
    });
  }

  preload() {}

  create() {
    this.rewardSound = this.sound.add("rewardSound");

    this.endOverlay = this.add
      .sprite(config.width / 2, config.height / 2, "endScreenOverlay")
      .setTint(0x000000)
      .setAlpha(0.5);

    this.spotlight = this.add.sprite(config.width / 2, config.height / 2, "spotlight_1");
    this.anims.create({
      key: "spotlightOpen_1",
      frames: this.anims.generateFrameNames("spotlight_1", {
        start: 0,
        end: 4,
        zeroPad: 0,
        prefix: "spotlightAnim",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "spotlightOpen_2",
      frames: this.anims.generateFrameNames("spotlight_2", {
        start: 5,
        end: 8,
        zeroPad: 0,
        prefix: "spotlightAnim",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "spotlightOpen_3",
      frames: this.anims.generateFrameNames("spotlight_3", {
        start: 9,
        end: 12,
        zeroPad: 0,
        prefix: "spotlightAnim",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "spotlightOpen_4",
      frames: this.anims.generateFrameNames("spotlight_4", {
        start: 13,
        end: 16,
        zeroPad: 0,
        prefix: "spotlightAnim",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "spotlightOpen_5",
      frames: this.anims.generateFrameNames("spotlight_5", {
        start: 17,
        end: 20,
        zeroPad: 0,
        prefix: "spotlightAnim",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "spotlightOpen_6",
      frames: this.anims.generateFrameNames("spotlight_6", {
        start: 21,
        end: 24,
        zeroPad: 0,
        prefix: "spotlightAnim",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.endConfetti = this.add.sprite(config.width / 2, config.height / 2, "endConfetti");
    this.anims.create({
      key: "endConfetti",
      frames: this.anims.generateFrameNames("endConfetti", {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.time.delayedCall(
      2000,
      function () {
        //this.spotlight.play("spotlightOpen");

        this.spotlight.play("spotlightOpen_1");

        this.spotlight.on(
          Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + "spotlightOpen_1",
          () => {
            this.spotlight.chain(["spotlightOpen_2", "spotlightOpen_3", "spotlightOpen_4", "spotlightOpen_5", "spotlightOpen_6"]);
          },
          this
        );
      },
      [],
      this
    );

    this.gameOver = this.add.sprite(config.width / 2, config.height / 2, "youWon").setAlpha(0);
    this.tweens.add({
      targets: this.gameOver,
      ease: "Expo.easeInOut",
      duration: 1000,
      delay: 300,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.gameOver],
      ease: "Linear",
      duration: 300,
      delay: 3000,
      y: {
        getStart: () => config.height / 2,
        getEnd: () => config.height / 2 - 50,
      },
      yoyo: false,
      loop: 0,
    });

    this.nextButton = this.add
      .sprite(config.width / 2, 740, "nextButton")
      .setAlpha(0)
      .setInteractive({ cursor: "pointer" });

    this.iconDisplay = this.add.sprite(config.width / 2 - 80, config.height / 2 + 100, "correctIcon").setAlpha(0);

    if (gameState.gameWin == false) {
      this.nextButton.setTexture("retryButton");
      this.gameOver.setTexture("gameOver");

      this.nextButton.on(
        "pointerover",
        function (pointer) {
          this.nextButton.setTexture("retry_button_on");
        },
        this
      );

      this.nextButton.on(
        "pointerout",
        function (pointer) {
          this.playButton.setTexture("retryButton");
        },
        this
      );

      this.iconDisplay.setTexture("incorrectIcon");
      this.retryText = this.add
        .text(config.width / 2 - 140, config.height / 2 + 200, `Solve atleast 6 problems correctly \n to clear the game`, {
          fontFamily: "font1",
          fontSize: "18px",
          fill: "#ffffff",
        })
        .setAlign("center")
        .setAlpha(0);
      this.tweens.add({
        targets: [this.retryText],
        ease: "Linear",
        duration: 300,
        delay: 3000,
        alpha: {
          getStart: () => 0,
          getEnd: () => 1,
        },
        y: {
          getStart: () => config.height / 2 + 200,
          getEnd: () => config.height / 2 + 150,
        },
        yoyo: false,
        loop: 0,
      });
    } else {
      this.endConfetti.play("endConfetti");

      this.nextButton.on(
        "pointerover",
        function (pointer) {
          this.nextButton.setTexture("next_button_on");
        },
        this
      );

      this.nextButton.on(
        "pointerout",
        function (pointer) {
          this.nextButton.setTexture("nextButton");
        },
        this
      );
    }

    this.nextButton.on(
      "pointerup",
      function () {
        if (gameState.gameWin == false) {
          this.resetGameData();
          this.scene.start("GameScene");
        } else {
        }
      },
      this
    );

    this.finalScore = this.add
      .text(config.width / 2 - 140, config.height / 2 + 140, `${gameState.score}/${gameState.attempted + 1} Problems`, {
        fontFamily: "font1",
        fontSize: "18px",
        fill: "#ffffff",
      })
      .setAlpha(0);

    this.hintsUsed = this.add
      .text(config.width / 2 + 30, config.height / 2 + 140, `${gameState.hints} Hints Used`, {
        fontFamily: "font1",
        fontSize: "18px",
        fill: "#ffffff",
      })
      .setAlpha(0);

    this.hintDisplay = this.add
      .sprite(config.width / 2 + 80, config.height / 2 + 100, "hintIcon")
      .setAlpha(0)
      .setScale(0.8);

    this.tweens.add({
      targets: [this.iconDisplay, this.hintDisplay],
      ease: "Linear",
      duration: 300,
      delay: 3000,
      y: {
        getStart: () => config.height / 2 + 100,
        getEnd: () => config.height / 2 + 50,
      },
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.finalScore, this.hintsUsed],
      ease: "Linear",
      duration: 300,
      delay: 3000,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      y: {
        getStart: () => config.height / 2 + 140,
        getEnd: () => config.height / 2 + 100,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.nextButton],
      ease: "Linear",
      duration: 300,
      delay: 3000,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      y: {
        getStart: () => 740,
        getEnd: () => 650,
      },
      yoyo: false,
      loop: 0,
    });

    this.reward = this.add.sprite(config.width / 2, config.height / 2, "rewardAnim_1");

    this.anims.create({
      key: "rewardShow_1",
      frames: this.anims.generateFrameNames("rewardAnim_1", {
        start: 0,
        end: 58,
        zeroPad: 0,
        prefix: "trophyAnim",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "rewardShow_2",
      frames: this.anims.generateFrameNames("rewardAnim_2", {
        start: 59,
        end: 74,
        zeroPad: 0,
        prefix: "trophyAnim",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    var frames_1 = this.anims.generateFrameNames("rewardAnim_2", {
      start: 75,
      end: 88,
      zeroPad: 0,
      prefix: "trophyAnim",
      suffix: ".png",
    });

    var frames_2 = this.anims.generateFrameNames("rewardAnim_3", { start: 89, end: 118, zeroPad: 0, prefix: "trophyAnim", suffix: ".png" });

    var frames_3 = this.anims.generateFrameNames("rewardAnim_4", {
      start: 119,
      end: 148,
      zeroPad: 0,
      prefix: "trophyAnim",
      suffix: ".png",
    });

    var frames_4 = this.anims.generateFrameNames("rewardAnim_5", {
      start: 149,
      end: 155,
      zeroPad: 0,
      prefix: "trophyAnim",
      suffix: ".png",
    });

    var finalFrames = frames_1.concat(frames_2, frames_3, frames_4);

    this.anims.create({
      key: "rewardLoop",
      frames: finalFrames,
      frameRate: 30,
      repeat: -1,
    });

    this.okButton = this.add
      .sprite(config.width / 2, 740, "okayButton")
      .setAlpha(0)
      .setInteractive({ cursor: "pointer" });

    this.okButton.on(
      "pointerover",
      function (pointer) {
        this.okButton.setTexture("okay_button_on");
      },
      this
    );

    this.okButton.on(
      "pointerout",
      function (pointer) {
        this.okButton.setTexture("okayButton");
      },
      this
    );

    this.nextButton.on("pointerup", (pointer) => {
      if (gameState.gameWin == false) {
        gameState.attempted = 0;
        gameState.score = 0;
        gameState.hints = 0;
        gameState.gameWin = false;

        this.cameras.main.fadeOut(500, 255, 255, 255);

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            this.scene.stop("EndScene");
            this.scene.start("TutorialScene");
          },
          this
        );
      } else {
        this.tweens.add({
          targets: [this.gameOver, this.iconDisplay, this.hintDisplay, this.finalScore, this.hintsUsed, this.nextButton],
          alpha: 0,
          duration: 300,
        });

        //this.spotlight.play("spotlightClose");

        this.time.delayedCall(
          1000,
          () => {
            this.reward.play("rewardShow_1");

            this.reward.on(
              Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + "rewardShow_1",
              () => {
                this.rewardSound.setLoop(false).setVolume(0.2).play();
                this.reward.play("rewardShow_2");
              },
              this
            );

            this.tweens.add({
              targets: this.okButton,
              ease: "Linear",
              duration: 300,
              delay: 3000,
              alpha: 1,
              y: 650,
            });

            this.add.sprite(577, 126, "rewardEarned").setOrigin(0);
            this.add.sprite(588, 580, "rewardName").setOrigin(0);
          },
          this
        );

        this.reward.on(
          Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + "rewardShow_2",
          () => {
            this.reward.play("rewardLoop");
          },
          this
        );
      }
    });

    this.okButton.on(
      "pointerup",
      () => {
        this.okButton.setTexture("okayDisabled");
        this.okButton.removeInteractive();
      },
      this
    );
  }

  resetGameData() {
    leftButton = null;
    rightButton = null;
    panel = null;
    progressBar = null;
    light_1 = null;
    light_2 = null;
    light_3 = null;
    light_4 = null;
    light_5 = null;
    light_6 = null;
    hintOpen = false;
    qnum = 0;
    True_tree = true;
    True_strip = true;
    qstatement = null;
    replayCount = 0;
    option = 0;
    checkOption = 0;
    adjustTimeScale = 1;
    hintOn = false;
    attempt = 0;
    correct = 0;
    attempts = 0;

    correctOption = null;

    c = null;

    replay_test = true;
    checkTest = false;
    tCheck = true;
    t_test = true;

    gameState.score = 0;
    gameState.attempted = 0;
    gameState.hints = 0;
    gameState.questionNumber = 0;
  }

  update() {}
}
